
import Vue from 'vue'
import router from '../router'
import uweb from 'vue-uweb'
const _uweb = uweb
Vue.use(_uweb, {
    siteId: '1268100633',
    debug: false,
    autoPageview: true,
    src: 'https://s13.cnzz.com/z_stat.php?id=1268100633&web_id=1268100633'
})

/* Vue全局注册 directive 埋点处理 */
const $uweb = _uweb;
router.afterEach((to, from) => {
    /*
    ** 告诉 uweb 增加一个 PV
    */
    $uweb.trackPageview(to.fullPath, "")
});

Vue.directive('point', {
    inserted: function (el, binding) {
        const _binding = binding.value
        el.addEventListener('click', () => {
            $uweb.trackEvent(_binding.category, _binding.action, _binding.label, _binding.value)
        })
    }
});

Vue.directive('point-input', {
    inserted: function (el, binding) {
        const _binding = binding.value
        el.addEventListener('keydown', (event) => {
            if (event.keyCode == "13") {
                $uweb.trackEvent(_binding.category, _binding.action, _binding.label, _binding.value)
            }
        })
    }
})